'use client'

import { useAtomValue } from 'jotai'

import { completedCount } from '@/features/tutorial/lib/tutorial-progress'
import { TUTORIALS } from '@/features/tutorial/lib/tutorials'
import { guidePreferencesReadyAtom, welcomeGuideAtom } from '@/state/onboarding'
import { presetTourDoneAtom } from '@/state/preset-tour'
import { tutorialProgressAtom } from '@/state/tutorial'

export interface TutorialCompletion {
  done: number
  total: number
  /** Every tutorial and both tours finished. */
  complete: boolean
  /** The saved record has loaded, so `done` is the user's, not this device's default. */
  ready: boolean
}

/**
 * How much of the hub the user has finished: every registered tutorial plus the welcome and
 * preset tours. The hub's progress bar and the side panel's ring both read this.
 */
export function useTutorialCompletion(): TutorialCompletion {
  const progress = useAtomValue(tutorialProgressAtom)
  const welcome = useAtomValue(welcomeGuideAtom)
  const presetDone = useAtomValue(presetTourDoneAtom)
  const ready = useAtomValue(guidePreferencesReadyAtom)
  const total = Object.keys(TUTORIALS).length + 2
  const done = completedCount(progress) + (welcome.dismissed ? 1 : 0) + (presetDone ? 1 : 0)
  return { done, total, complete: done >= total, ready }
}
